import { Reveal, Label } from "./motion";
import { MANIFESTO } from "../data";

export const Manifesto = () => (
  <section id="method" className="px-4 md:px-8 lg:px-12 py-24 md:py-32 lg:py-48 bg-[#0A0A0A]" data-testid="manifesto-section">
    <Reveal><Label>02 — The Method</Label></Reveal>
    <Reveal delay={0.1}>
      <h2 className="font-display text-5xl sm:text-6xl lg:text-8xl leading-none mt-6 text-white max-w-4xl">
        What I believe about training
      </h2>
    </Reveal>

    <div className="mt-16 lg:mt-24 border-t border-zinc-800">
      {MANIFESTO.map((m, i) => (
        <Reveal key={m.n} delay={i * 0.05}>
          <div className="group grid md:grid-cols-12 gap-4 md:gap-8 py-10 md:py-14 border-b border-zinc-800 hover:bg-[#121212] transition-colors px-2 md:px-6" data-testid={`manifesto-${m.n}`}>
            <div className="md:col-span-2 font-display text-6xl md:text-7xl text-stroke group-hover:text-[#FF3B30] group-hover:[-webkit-text-stroke:0] transition-colors">
              {m.n}
            </div>
            <h3 className="md:col-span-5 font-display text-3xl md:text-4xl text-white leading-none self-center">
              {m.title}
            </h3>
            <p className="md:col-span-5 text-zinc-400 text-base lg:text-lg leading-relaxed self-center">
              {m.body}
            </p>
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);
